<template>
    <div class="notice content-continer">
        <div class="notice-title">通知公告</div>
        <ul>
            <li>
                <span class="title-icon"></span>
                <a>抗菌药物临床应用管理办法》和抗菌药物临床应用管理工作情况介绍</a>
                <span class="time">2019-08-01</span>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "notice",
        data() {
            return {

            };
        },
        methods: {
            // 鼠标移入加入class
            changeActive($event) {
                $event.currentTarget.className = "list-active";
            },
            removeActive($event) {
                $event.currentTarget.className = "";
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .notice-title {
        color: #3672BF;
        border-bottom: solid 1px #3672BF;
        margin-top: 50px;
        padding-bottom: 15px;
        font-size: 18px;
        font-weight: bold;
        padding-left: 20px;
    }

    .notice li {
        height: 56px;
        cursor: pointer;
        font-size: 18px;
        border-bottom: dashed 1px #CCCCCC;
    }

    .notice a {
        font-size: 14px;
        color: #4d4d4d;
        margin-left: 20px;
        line-height: 56px;
        
    }

    .notice ul {
        margin-bottom: 200px;
    }

    .title-icon {
        display: inline-block;
        width: 4px;
        height: 4px;
        background: #4d4d4d;
        margin-top: 28px;
        float: left;
    }

    .time {
        font-size: 12px;
        display: inline-block;
        width: 74px;
        height: 18px;
        border: 1px solid rgba(204, 204, 204, 1);
        color: #CCCCCC;
        float: right;
        margin-top: 19px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Industry.vue